(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linephra-footer"]) return;
  try {
    
const footerMedia = window.matchMedia('(max-width: 749px)');
function syncFooterAccordions() {
  document.querySelectorAll('.lp-ref-footer__column').forEach((column) => {
    column.open = !footerMedia.matches;
  });
}
syncFooterAccordions();
footerMedia.addEventListener('change', syncFooterAccordions);
document.addEventListener('shopify:section:load', syncFooterAccordions);
document.addEventListener('click', (event) => {
  if (!footerMedia.matches && event.target.closest('.lp-ref-footer__column > summary')) event.preventDefault();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linephra-judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#linephra-customer-reviews"]');
  if (!link) return;
  const target = document.getElementById('linephra-customer-reviews');
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  target.scrollIntoView({behavior: 'smooth', block: 'start'});
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
